import { useQuery } from '@tanstack/react-query';

import axios from 'src/utils/axios';

interface PaginationOptions {
  page?: number;
  page_size?: number;
  analysis_type?: string;
  sort_by?: string;
  sort_order?: string;
}

export const getIntents = async ({
  page = 1,
  page_size = 10,
  analysis_type,
  sort_by = 'created_at',
  sort_order = 'desc',
}: PaginationOptions = {}) => {
  const response = await axios.get('/intents', {
    params: {
      page,
      page_size,
      analysis_type,
      sort_by,
      sort_order,
    },
  });
  return response.data;
};

export function useIntents(paginationOptions: PaginationOptions) {
  const { data, isLoading, refetch } = useQuery({
    queryKey: ['intents', paginationOptions],
    queryFn: () => getIntents(paginationOptions),
  });

  return {
    data,
    isLoading,
    refetch,
  };
}
